"use client";

import NextImage, { getImageProps } from "next/image";
import { useEffect } from "react";
import aa from "search-insights";

import { css } from "@/../styled-system/css";
import { EventType } from "@/actions/events/EventTypes/types";
import { sendUserEvents } from "@/actions/events/send-user-event-rpc";
import { ProductCardType } from "@/types/Common/ProductCardType";

import { Link } from "../ui/Link";

const recommendedProductCardClass = css({
  display: "block",
  position: "relative",
  width: "200px",
  rounded: "3xl",
  cursor: "pointer",
  overflow: "hidden",
  transition: "all 0.3s ease-in-out",
  _hover: {
    shadow: "md",
  },
});

const nameSpanClass = css({
  color: "brandBlack",
  wordBreak: "break-word",
  lineClamp: 2,
  textOverflow: "ellipsis",
  fontSize: "lg",
  fontWeight: "medium",
  _before: {
    position: "absolute",
    content: '""',
    bottom: "0",
    left: "0",
    right: "0",
    top: "0",
  },
});

const priceSpanClass = css({
  wordBreak: "break-word",
  lineClamp: 1,
  textOverflow: "ellipsis",
  fontSize: "lg",
  fontWeight: "bold",
  color: "brandTeal",
});

type EventObject = {
  eventName: string;
  index: string;
  objectIDs: string[];
  userToken?: string;
  authenticatedUserToken?: string;
};

interface NewProductCardProps {
  slug: string;
  name: string;
  price: number;
  image_url: string;
}

export default function NewProductCard({
  slug,
  name,
  price,
  image_url,
}: NewProductCardProps) {
  //   const onClick = async () => {
  //     await sendUserEvents(EventType.Click, [productId]);
  //     const userToken = token;
  //     let eventObject: EventObject = {
  //       eventName: "Product Clicked",
  //       index: process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_INDEX!,
  //       objectIDs: [productId],
  //     };
  //     if (userToken) {
  //       const sanitizedToken = userToken.replace(/[^a-zA-Z0-9_-]/g, "");
  //       const validToken = sanitizedToken.substring(0, 64);
  //       eventObject = {
  //         ...eventObject,
  //         userToken: validToken,
  //         authenticatedUserToken: validToken,
  //       };
  //     }

  //     aa("clickedObjectIDs", eventObject, {
  //       inferQueryID: true,
  //     });

  //     // window.open(`/products/${slug}`, "_self");
  //   };

  //   const prefetchProps = getImageProps({
  //     height: 256,
  //     quality: 80,
  //     width: 256,
  //     // TODO: change placeholder
  //     src: image_url ?? "/placeholder.svg?height=64&width=64",
  //     alt: `A small picture of ${name}`,
  //   });

  //   useEffect(() => {
  //     try {
  //       const iprops = prefetchProps.props;
  //       const img = new Image();
  //       // Don't interfer with important requests
  //       (img as HTMLImageElement & { fetchPriority?: string }).fetchPriority =
  //         "low";
  //       // Don't block the main thread with prefetch images
  //       img.decoding = "async";
  //       // Order is important here, sizes must be set before srcset, srcset must be set before src
  //       //   if (iprops.sizes) img.sizes = iprops.sizes;
  //       //   if (iprops.srcSet) img.srcset = iprops.srcSet;
  //       if (iprops.src) img.src = iprops.src;
  //     } catch (e) {
  //       console.error("failed to preload", prefetchProps.props.src, e);
  //     }
  //   }, [prefetchProps]);

  return (
    <div className={recommendedProductCardClass}>
      <div
        className={css({
          position: "relative",
          backgroundColor: "gray.50",
        })}
      >
        <NextImage
          unoptimized
          decoding="sync"
          loading="eager"
          src={image_url}
          width={0}
          height={0}
          sizes="100vw"
          className={css({
            width: "100%",
            height: "auto",
            aspectRatio: "1",
            mixBlendMode: "multiply",
          })}
          alt={name}
        />
      </div>
      <div className={css({ px: "5", pt: "2", pb: "5" })}>
        <div
          className={css({
            mb: "1.5",
            height: "3.375rem",
          })}
        >
          <Link
            className={nameSpanClass}
            href={`/products/${slug}`}
            // onClick={onClick}
            prefetch={true}
          >
            {name}
          </Link>
        </div>
        <div
          className={css({
            lineHeight: "none",
          })}
        >
          <span className={priceSpanClass}>${price}+</span>
        </div>
      </div>
    </div>
  );
}
